import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is handled via httpOnly cookies set by the backend
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_laronta-logistics/artifacts/73syqhfl_FullLogo_NoBuffer.jpg";

export const COMPANY = {
  name: "Laronta Pro Logistics LLC",
  tagline: "Reliable. Professional. On Time.",
  phone: "(385) 424-6444",
  phoneRaw: "3854246444",
  email: "larontaprotaxservices@gmail.com",
  location: "Salt Lake City, Utah",
  hours: [
    ["Monday – Friday", "7:00 AM – 6:00 PM"],
    ["Saturday", "By Appointment"],
    ["Sunday", "Closed"],
  ],
  coverage: [
    "Salt Lake City, UT — HQ",
    "Mountain West",
    "West Coast",
    "Southwest",
    "Midwest",
    "South",
    "East Coast",
    "All 50 States",
  ],
};
